import { gql } from "@apollo/client";

export const GET_IMPRIMIR_MINUTAS = gql`
    query GetImprimirMinutasGrilla($filter: ImprimirMinutaFilterInput!) {
        imprimirMinutasGrilla(filter: $filter) {
            idMinuta,
            idEvaluacion,
            paciente,
            cantConexiones,
            modulo,
            cliente,
            nombreCliente,
            delegacion,
            precioDiario,
            total,
            numeroFactura,
            estado,
            observaciones,
            planCuidado,
            fechaAlta
        }
    }
`;

export const adaptImprimirMinutas = (minuta) => {
  return {
    idMinuta: minuta?.idMinuta,
    idEvaluacion: minuta?.idEvaluacion,
    paciente: minuta?.paciente,
    cantConexiones: minuta?.cantConexiones,
    modulo: minuta?.modulo,
    nombreCliente: minuta?.nombreCliente,
    cliente: minuta?.cliente,
    delegacion: minuta?.delegacion,
    precioDiario: minuta?.precioDiario,
    total: minuta?.total,
    numeroFactura: minuta?.numeroFactura,
    estado: minuta?.estado,
    observaciones: minuta?.observaciones,
    planCuidado: minuta?.planCuidado,
    fechaAlta: minuta?.fechaAlta
  };
};

export const adaptImprimirMinutasArray = (minutas) => {
  return structuredClone(minutas)?.
  map((minuta) => adaptImprimirMinutas(minuta));
};